import { useContext, useEffect } from "react";
import { authSuccess, logoutUser, saveOperatorAuthToken } from "app/pages/Auth/AuthActions";
import { parseQueries } from "app/utils/routerUtils";
import { Navigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateStrategy } from "app/reducers/partnerActionCreators";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import AppGlobalsContext from "app/AppGlobalsContext";
import { COOKIES_AUTH_EXPIRES } from "app/constants";

const OperatorRedirect = ({ updateStrategy, authSuccess, logoutUser, saveOperatorAuthToken }) => {
	const { search } = useLocation();
	const { shop } = useContext(AppGlobalsContext);
	const query = parseQueries(search);

	const { uuid, email, token, partner, redirectUrl, strategy, agentToken } = query;

	useEffect(() => {
		// Pour les brands ayant une stack membre, on authentifie le user
		if (uuid && email && token && partner) {
			logoutUser();
			authSuccess({
				data: {
					uuid,
					email,
					token,
					partner: { code: partner },
				},
			});
		} else {
			Cookies.set("authToken", token, {
				expires: COOKIES_AUTH_EXPIRES,
				path: `/${shop}`,
			});
		}

		if (strategy) {
			updateStrategy(strategy);
		}

		if (agentToken) {
			saveOperatorAuthToken(agentToken);
		}
	}, [uuid, email, token, partner, strategy, agentToken]);

	const pathname = redirectUrl && !redirectUrl.includes("://") ? redirectUrl : "/listing";

	const [redirectUrlPathname, redirectUrlSearch] = pathname.split("?");

	return (
		<Navigate
			to={{ pathname: redirectUrlPathname, search: redirectUrlSearch }}
			replace={true}
		/>
	);
};

OperatorRedirect.propTypes = {
	updateStrategy: PropTypes.func,
	authSuccess: PropTypes.func,
	saveOperatorAuthToken: PropTypes.func,
	logoutUser: PropTypes.func,
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{ updateStrategy, authSuccess, logoutUser, saveOperatorAuthToken },
		dispatch
	);
};

export default connect(
	null,
	mapDispatchToProps
)(OperatorRedirect);
